import React from 'react';
import * as PropTypes from 'prop-types';
import { ChartWrapper, ProgressCircle, Overlay } from './elements';

function ProgressCirlce(props) {
  return (
    <ChartWrapper className={props.className}>
      <ProgressCircle
        percent={Math.min(props.percent, 100)}
        color={props.color}
      />
      {props.children && <Overlay>{props.children}</Overlay>}
    </ChartWrapper>
  );
}

ProgressCirlce.propTypes = {
  className: PropTypes.string,
  percent: PropTypes.number,
  children: PropTypes.node,
  color: PropTypes.string,
};

export default ProgressCirlce;
